import axios from 'axios';
import { Dispatch } from 'redux';
import firebase from '../../config/firebase';
import { API_KEY } from '../../constants';

export const signInAdmin = () => (dispatch: Dispatch) => {
	const provider = new firebase.auth.GoogleAuthProvider();
	firebase
		.auth()
		.signInWithPopup(provider)
		.then((result: any) => {
			return result.user.getIdToken();
		})
		.then(idToken => {
			axios.post(`${API_KEY}/auth/setAdminCustomClaims`, {
				idToken,
				tipoUsuario: 'admin'
			});
		});
};
